import { Constructor } from "./Extensions";
import { ObjectHelper } from "./Helpers/ObjectHelper";
import { NAMESPACE } from "./_Namespace";

export class Assert
{
    public static classNamespace = NAMESPACE + "Assert";
    public static className = "Assert";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    public static equals<T, U extends T>(value: T, comparison: U, name: string): asserts value is U
    {
        if (value !== comparison)
            throw new Error(`${name} is not "${comparison}"`);
    }
    public static isAssignableTo<T>(obj: any, classFullName: string): asserts obj is T
    public static isAssignableTo<T>(obj: any, classInfo: { fullName: string, interfaceType?: T }): asserts obj is T
    public static isAssignableTo<T>(obj: any, classFullNameOrClassInfo: string | { fullName: string, interfaceType?: T }): asserts obj is T
    {
        if (!ObjectHelper.isAssignableTo(obj, classFullNameOrClassInfo))
        {
            const
                classFullName = typeof classFullNameOrClassInfo === "string" ? classFullNameOrClassInfo : classFullNameOrClassInfo.fullName;

            throw new Error(`${obj} is not assignable to ${classFullName}`);
        }
    }
    public static isNotNullOrUndefined<T>(value: T, name: string): asserts value is NonNullable<T>
    {
        if (value === null)
            throw new Error(`${name} is null`);
        else if (value === undefined)
            throw new Error(`${name} is undefined`);
    }
    public static isInstanceOf<T>(constructor: Constructor<T>, value: any, name: string): asserts value is T
    {
        if (!value || !(value instanceof constructor))
            throw new Error(`${name} is not an instance of the expected type`);
    }
    public static isInstanceOfClass<T, TArgs extends any[] = any>(constructor: Function & { apply: (this: any, args: TArgs) => void, prototype: T }, value: any, name: string): asserts value is T
    {
        if (!value || !(value instanceof constructor))
            throw new Error(`${name} is not an instance of the expected type`);
    }
    public static isString(obj: any, name: string): asserts obj is string
    {
        if (typeof obj !== "string")
            throw new Error(`${name} is not a string`);
    }
}